import { TimesheetPage } from "./TimesheetPage";

import { ClockIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

/**
 * Timesheet feature registration. This is the public surface of the feature.
 * Gated on feature.timesheet.access — a pilot granted per person from the
 * access UI (client mirror of the server gate).
 */
export const timesheetFeature: FeatureModule = {
  id: "timesheet",
  navItems: [
    {
      id: "timesheet",
      label: "Timesheet",
      path: ROUTES.timesheet,
      icon: ClockIcon,
      requires: "feature.timesheet.access",
    },
  ],
  routes: [
    {
      path: "timesheet",
      element: (
        <RequirePermission perm="feature.timesheet.access" redirectTo={ROUTES.overview}>
          <TimesheetPage />
        </RequirePermission>
      ),
    },
  ],
};
